module.exports = __webpack_public_path__ + "static/media/addlocation.3dc93ed3.png";